import type { StatusPesquisaT } from '@licita-mind/shared-types';
import { cn } from '../lib/cn';

const CORES: Readonly<Record<StatusPesquisaT, string>> = {
  RASCUNHO: 'bg-navy-100 text-navy-700',
  COLETANDO_PRECOS: 'bg-blue-100 text-blue-700',
  CESTA_FORMADA: 'bg-amber-100 text-amber-800',
  JUSTIFICATIVA_GERADA: 'bg-violet-100 text-violet-700',
  DOCUMENTO_ASSINADO: 'bg-emerald-100 text-emerald-700',
  FINALIZADA: 'bg-emerald-200 text-emerald-900',
  CANCELADA: 'bg-red-100 text-red-700',
};

const LABELS: Readonly<Record<StatusPesquisaT, string>> = {
  RASCUNHO: 'rascunho',
  COLETANDO_PRECOS: 'coletando preços',
  CESTA_FORMADA: 'cesta formada',
  JUSTIFICATIVA_GERADA: 'justificativa gerada',
  DOCUMENTO_ASSINADO: 'documento assinado',
  FINALIZADA: 'finalizada',
  CANCELADA: 'cancelada',
};

export const StatusBadge = ({
  status,
  className,
}: {
  status: StatusPesquisaT;
  className?: string;
}) => (
  <span className={cn('badge', CORES[status], className)}>{LABELS[status]}</span>
);
